import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface EditFeeDialogData {
  runLabel: string;
  feeSnapshot: number;
}

@Component({
  selector: 'app-edit-fee-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './edit-fee-dialog.html',
  styleUrl: './edit-fee-dialog.scss',
})
export class EditFeeDialog {
  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<EditFeeDialog>);
  readonly data = inject<EditFeeDialogData>(MAT_DIALOG_DATA);

  form: FormGroup = this.fb.group({
    fee_snapshot: [this.data.feeSnapshot, [Validators.required, Validators.min(0)]],
  });

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.dialogRef.close(this.form.value.fee_snapshot as number);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  getErrorMessage(): string {
    const c = this.form.get('fee_snapshot');
    if (!c) return '';
    if (c.hasError('required')) return 'This field is required';
    if (c.hasError('min')) return 'Minimum value is 0';
    return '';
  }
}
